module.exports = __webpack_public_path__ + "static/media/img-scope6.f64400b6.png";